import axios from "./axiosInstance";

const TermsAPI = {
  getTermsConditions: () => axios.get("/terms-conditions"), // Direct endpoint
};

export default TermsAPI;